const categories = {
  HIGHLIGHTS: 'highlights',
  FEATURES: 'features',
  PROTECTION: 'protection',
  AWARDS_AND_RATINGS: 'awards-and-ratings',
  INCENTIVES_AND_REBATES: 'incentives-and-rebates',
};

const subCategories = {
  WARRANTY: 'warranty',
  INSURANCE: 'insurance',
  APPEARANCE: 'appearance',
  FINANCIAL: 'financial',
};

const internalNames = {
  autoverify: {
    'VEHICLE-SERVICE-CONTRACTS': 'autoverify_vehicle-service-contracts',
    'PREPAID-MAINTENANCE-PLANS': 'autoverify_prepaid-maintenance-plans',
    'GAP-INSURANCE': 'autoverify_gap-insurance',
    'TIRE-WHEEL-PLAN': 'autoverify_tire-wheel-plan',
    'INTERIOR-EXTERIOR-PLANS': 'autoverify_interior-exterior-plans',
    'INCENTIVES-AND-REBATES': 'autoverify_incentives-and-rebates',
    'AWARDS-AND-RATINGS': 'autoverify_awards-and-ratings',
    'LOW-MILEAGE': 'autoverify_low-mileage',
    'NEW-LISTING': 'autoverify_new-listing',
    'PRICE-REDUCTION': 'autoverify_price-reduction',
    'VEHICLE-COMPARISON': 'vehicle-comparison', // TODO: this must match the back-end value when it is implemented
    'HIGH-SAFETY-RATING': 'high-safety-rating', // TODO: this must match the back-end value when it is implemented
    'GETTING-NOTICED': 'autoverify_getting-noticed',
    'GREAT-DEAL': 'autoverify_great-deal', // TODO: this must match the back-end value when it is implemented
  },
  siriusXm: {
    'VEHICLE-PROGRAM': 'sirius-xm_vehicle-program',
  },
  firstCanadian: {
    BREAKDOWN: 'first-canadian_breakdown',
    PLATINUM: 'first-canadian_platinum',
  },
  walkaway: {
    walkaway: 'walkaway', // TODO: this must match the back-end value when it is implemented
  },
  vendors: {
    ia: {
      COMPANION_REPLACEMENT_WARRANTY: 'ia_companion-replacement-warranty',
      EXTERIOR: 'ia_exterior',
      PPP_ALLIED: 'ia_ppp-allied',
      INTERIOR: 'ia_interior',
      ADVANTAGE_81_A: 'ia_avantage-81-a',
      TIRE_AND_RIM_PROTECTION: 'ia_tira-and-rim-protection',
      AUTO_PREMIUM: 'ia_auto-premium',
      MAXUM: 'ia_maxum',
      INCIDENT_PROTECTION: 'ia_incident-protection',
      AUTO_PRIME_PROTECTION: 'ia_auto-prime-protection',
      ELECTRONIC_CORROSION_PROTECTION_UNIT: 'ia_electronic-corrosion-protection-unit',
      AVANTAGE_EL7A_EX7A: 'ia_avantage-el7a-ex7a',
      AVANTAGE_EL_A: 'ia_avantage-el-a',
      ROAD_PROTECTION: 'ia_road-protection',
      IMAGE_GUARD: 'ia_image-guard',
      AUTO_MECHANICAL_ASSISTANCE: 'ia_auto-mechanical-assistance',
      SHERLOCK: 'ia_sherlock',
      COMPANION_II: 'ia_companion-ii',
      REPLACEMENT_INSURANCE: 'ia_replacement-insurance',
      AVANTAGE_84_P: 'ia_avantage-84-p',
      AVANTAGE_70_P: 'ia_avantage-70-p',
      PREMIUM_SOUND_SHIELD: 'ia_premium-sound-shield',
      AUTO_ESSENTIAL: 'ia_auto-essential',
      GUARANTEED_ASSET_PROTECTION: 'ia_guaranteed-asset-protection',
      EXTEND_EXCEL_TOTAL: 'ia_extend-excel-total',
      AUTO_ALL_OCCASIONS_PLUS: 'ia_auto-all-occasions-plus',
      PREMIUM_RUST_PROTECTION: 'ia_premium-rust-protection',
      SURFACE_PERFORATION: 'ia_surface-perforation',
      INVISITRAK: 'ia_invisitrak',
      SURFACE_PERFORATION_AND_IMAGE_GUARD: 'ia_surface-perforation-and-image-guard',
    },
    lubrico_warranty: {
      LUBRICO_WARRANTY: 'lubrico_warranty',
      PROGRAMS_AND_DETAILS: 'lubrico_warranty_programs_and_details',
    },
    auto_shield: {
      ROAD_HAZARD_LITE: 'auto-shield_road-hazard-lite',
      ROAD_HAZARD: 'auto-shield_road-hazard',
      ROAD_HAZARD_PLUS: 'auto-shield_road-hazard-plus',
      ROAD_HAZARD_PRO: 'auto-shield_road-hazard-pro',
      THEFT_PROTECTION_MEMBERSHIP: 'auto-shield_theft-protection-membership',
      JOB_LOSS_MEMBERSHIP: 'auto-shield_job-loss-membership',
      FINANCIAL_LOSS_MEMBERSHIP: 'auto-shield_financial-loss-membership',
      P2_GRAPHENE_PURE: 'auto-shield_p2-graphene-pure',
    },

    global_warranty: {
      ULTIMATE_AUTOMOTIVE_PROTECTION: 'global-warranty_ultimate-automotive-protection',
      ULTIMATE_TIRE_RIM_PROTECTION: 'global-warranty_ultimate-tire-rim-protection',
      GLOBAL_ASSET_PROTECTION: 'global-warranty_global-asset-protection',
      GLOBAL_GLASS_PROTECTION: 'global-warranty_global-glass-protection',
      GLOBAL_ROADSIDE: 'global-warranty_global-roadside',
    },
  },
};

export default { categories, subCategories, internalNames };
